import HomeProduct from "./components/home.product";
import HomeDeal from "./components/home.deal";
import HomeCategory from "./components/home.category";
import HomeSearchFilter from "./components/home.search.filter";
import HomeNews from "./components/home.news";
import Container from "../../components/element/container";
import Col from "../../components/element/col";
import useWindowDimension from "../../components/hook/use.window.dimension";
import HomeHero from "./components/home.hero";
import HomeSidebar from "./components/home.sidebar";
import HomeBanner from "./components/home.banner";

export default function Home() {
  const { isDesktop } = useWindowDimension();

  return (
    <Container className="home">
      <HomeSidebar />
      <Col className="_col home-content px-3 w-100">
        {isDesktop && <HomeDeal />}
        <section className="search-banner">
          <HomeSearchFilter section="search" />
          {isDesktop && <HomeBanner />}
        </section>
        <section className="feature-row">
          {isDesktop && <HomeHero />}
          <HomeNews />
        </section>
        <HomeCategory />
        <HomeSearchFilter section="filter" showModal={!isDesktop} />
        <HomeProduct showBanner={!isDesktop} showReserver={!isDesktop} />
      </Col>
    </Container>
  );
}
